/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

const initFold = function() {
  const $el = $('.sales .above-fold').first();
  const {
    top
  } = $el.offset();
  const height = $(window).height();

  $el.css("height", height - top);

  const h = Math.max(0, (height - 660)/3);
  return $el.find('.above-fold-content-wrapper').css("top", h);
};

const initSalesLinks = () => $('.sales a[href^="#"]').each(function(i, link) {
  const href = $(link).prop("href");
  const index = href.indexOf("#");
  const name = href.substring(index + 1);

  if (name.length > 0) {
    return $(link).click(function() {
      scrollTo(name);
      return false;
    });
  }
});

const initLandingBanner = function() {
  const banner = $('.landing-page-banner');
  return $('.dismiss a').on('click', function(e) {
    e.preventDefault();
    return banner.remove();
  });
};

/*
$(function() {
  if ($('.sales .above-fold').length) {
    initFold();
  }
  if ($('.sales a[href^="#"]').length) {
    initSalesLinks();
  }
  if ($('.landing-page-banner').length) {
    return initLandingBanner();
  }
});
*/

function initSalesOnLoad() {
  if ($('.sales .above-fold').length) {
    initFold();
  }
  if ($('.sales a[href^="#"]').length) {
    initSalesLinks();
  }
  if ($('.landing-page-banner').length) {
    return initLandingBanner();
  }
}

$(initSalesOnLoad);
document.addEventListener('turbo:load', initSalesOnLoad);
